// extracted by mini-css-extract-plugin
export default {"cls1":"Link-cls1_QZn","cls2":"Link-cls2__Vy Link-cls1_QZn"};